import React, { Fragment, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { AuthContext } from '../context/authContext';

import FormInput from '../components/form/input';
import FormButton from '../components/form/button';
import FormCheckBox from '../components/form/checkbox';

const SignInSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Email is Required'),
  password: Yup.string().required('Password is Required')
});

const SessionExpired = () => {
  const { login, auth, isAuthenticated, setSession } = useContext(AuthContext);
  const { email } = isAuthenticated().user;

  const [rememberMe, setRememberMe] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  return (
    <div className="show transition-opacity duration-200 ease-in-out">
      <div className="fixed z-50 modal-bg-clear">
        <div className="flex flex-wrap items-center justify-center h-screen w-screen">
          <div className="relative bg-white w-85 md:w-110 rounded shadow-cfw p-10">
            <h6 className="text-center">Your Session Has Expired</h6>
            <p className="text-center text-xs">
              Please re-enter your {errorMessage && 'email &'} password for re-authentication
            </p>
            {errorMessage && (
              <div
                className="text-center text-sm bg-red-100 border-l-8 border-red-500 text-red-700 p-1 mt-2"
                role="alert"
              >
                {errorMessage}
              </div>
            )}
            <div className="relative bg-cf-200 mt-4">
              <div className="absolute left-0 top-0 bottom-0 border-l-8 w-16 border-cf-300"></div>
              <div className="p-6 text-xs md:text-sm text-center">
                <Formik
                  initialValues={{
                    email,
                    password: ''
                  }}
                  validationSchema={SignInSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    (async () => {
                      try {
                        setSubmitting(true);
                        const response = await login(values);
                        setSubmitting(false);
                        if (response.code === 200) {
                          auth(response.data, rememberMe);
                          setSession(true);
                        } else {
                          throw response.data.message;
                        }
                      } catch (error) {
                        let errMgs = error;
                        if (typeof error !== 'string') {
                          errMgs = 'Unexpected server error';
                        }
                        setErrorMessage(errMgs);
                      }
                    })();
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting
                  }) => (
                    <Fragment>
                      <form className="md:flex block md:flex  md:flex-wrap" onSubmit={handleSubmit}>
                        {errorMessage && (
                          <FormInput
                            error={errors.email}
                            touched={touched.email}
                            className="w-full md:w-1/2 md:pr-2 mb-6 md:mb-0"
                            change={handleChange}
                            blur={handleBlur}
                            inputValue={values.email}
                            type="email"
                            id="email"
                            placeholder="johndoe@example.com"
                            title="Email"
                            inputType
                          />
                        )}

                        <FormInput
                          error={errors.password}
                          touched={touched.password}
                          className={`w-full ${errorMessage && 'md:w-1/2 md:pl-2'}`}
                          change={handleChange}
                          blur={handleBlur}
                          inputValue={values.password}
                          type="password"
                          id="password"
                          placeholder="*********"
                          title="Password"
                          inputType
                          passwordShow
                        />

                        <FormCheckBox
                          name="rememberMe"
                          className="text-xs ml-auto mt-1"
                          click={() => setRememberMe(!rememberMe)}
                          content="Remember Me!"
                        />

                        <FormButton
                          loading={isSubmitting}
                          name="Login"
                          className="w-full"
                          color="bg-cf-300"
                          btnPad="px-4 py-3 my-3"
                        />

                        <small className="mx-auto">
                          <Link to="/forgot-password">
                            Forgot password? <span className="text-cf-300">Click Here</span>
                          </Link>
                        </small>
                      </form>
                    </Fragment>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;
